import { useMemo } from 'react';
import { menuItems } from '../../data/menuItems';
import { useAdminPermissions } from '../../hooks/useAdminPermissions';
import SidenavMenuItem from './SidenavMenuItem';

const SidenavMenu: React.FC = () => {
  const currentPath = window.location.pathname;
  const { hasPermission } = useAdminPermissions();

  const menuItemsFiltered = useMemo(() => {
    const isResearcherOnly = hasPermission('research.view') && !hasPermission('clinic.view');

    if (isResearcherOnly) {
      return menuItems.filter(item => {
        if (
          item.path === 'research' ||
          item.path === 'clinical-skills' ||
          item.path === 'dashboard'
        ) {
          return true;
        }

        return false;
      });
    }

    return menuItems.filter(item => {
      if (item.path === 'admin-users' && !hasPermission('admin_users.view')) {
        return false;
      }

      if (item.path === 'flags' && !hasPermission('flags.view')) {
        return false;
      }

      if (item.path === 'developer-tools' && !hasPermission('devtools.access')) {
        return false;
      }

      return true;
    });
  }, [hasPermission]);

  return (
    <div className="space-y-1">
      {menuItemsFiltered?.map(menuItem => (
        <SidenavMenuItem
          key={menuItem.path}
          currentPath={currentPath}
          path={menuItem.path}
          icon={menuItem.icon}
          title={menuItem.title}
          menuItems={menuItem.menuItems}
          external={menuItem.external}
        />
      ))}
      {/* <div className="pt-8">
        <h3
          className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider"
          id="teams-headline"
        >
          Shortcuts
        </h3>
        <div
          className="mt-1 space-y-1"
          role="group"
          aria-labelledby="teams-headline"
        >
          <a
            href="https://chiroup.com/blog/"
            target="_blank"
            rel="noreferrer"
            className="group flex items-center px-3 py-2 text-base leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
          >
            <span
              className="w-2.5 h-2.5 mr-4 bg-yellow-500 rounded-full"
              aria-hidden="true"
            />
            <span className="truncate">ChiroUp Blog</span>
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default SidenavMenu;
